import "../../internal/features/config/middleware.js";
import "../../internal/features/config/reducer.js";
import { selectConfig } from "../../internal/features/config/selectors.js";
import { useAppActions } from "../../internal/shared/lib/store/hooks/useAppActions.js";
import { useAppSelector } from "../../internal/shared/lib/store/hooks/useAppSelector.js";
function useConfig() {
  const config = useAppSelector(selectConfig);
  const {
    config: { setApiRoot, setClientId, setReportConfig }
  } = useAppActions();
  return {
    data: config,
    actions: {
      setApiRoot,
      setClientId,
      setReportConfig
    }
  };
}
export {
  useConfig
};
